import { mui, React, ts, ui } from '_core';

import EmbedHeader from './embed-header';
import ErrorComponent from './error-component';

type ChartRendererProps = { widgetData: ts.types.analysis.EmbedChartData; fullScreen: boolean; download: boolean };
const ChartRenderer = ({ widgetData, fullScreen, download }: ChartRendererProps) => {
  const renderChart = () => {
    if (widgetData.chart_type === 'line-chart-v5') {
      return (
        <ui.LineChart
          {...widgetData.args}
          id={widgetData.id}
          data={widgetData.args.data}
          readOnly={false}
          fullScreen={fullScreen}
          download={download}
        />
      );
    }

    if (widgetData.chart_type === 'stacked-chart-v5') {
      return (
        <ui.StackedChart
          {...widgetData.args}
          id={widgetData.id}
          data={widgetData.args.data}
          readOnly={false}
          fullScreen={fullScreen}
          download={download}
        />
      );
    }

    if (widgetData.chart_type === 'nested-bar-chart-v5') {
      return (
        <ui.NestedBarChart
          {...widgetData.args}
          id={widgetData.id}
          data={widgetData.args.data}
          readOnly={false}
          fullScreen={fullScreen}
          download={download}
        />
      );
    }

    if (widgetData.chart_type === 'radar-chart-v5') {
      return (
        <ui.RadarChart
          {...widgetData.args}
          id={widgetData.id}
          data={widgetData.args.data}
          labels={widgetData.args.labels}
          dimensions={widgetData.args.dimensions}
          readOnly={false}
          fullScreen={fullScreen}
          download={download}
        />
      );
    }

    return <ErrorComponent />;
  };

  return (
    <mui.core.Box height="100%" display="flex" flexDirection="column">
      <EmbedHeader title={widgetData.widgetTitle} subtitle={widgetData.widgetSubTitle} fullScreen={fullScreen} />
      {renderChart()}
    </mui.core.Box>
  );
};

export default ChartRenderer;
